import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import customConstants from "../Globals";
import {NotificationManager} from "react-notifications";
import Dropzone from 'react-dropzone';
import forensicLib from "../assets/js/forensicLib";
import Loading from 'react-fullscreen-loading';
import moment from 'moment';
import 'moment/locale/tr';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import Gesture from "@material-ui/icons/Gesture";
import TextField from "@material-ui/core/TextField";
import Compare from "@material-ui/icons/Compare";
import {Alert} from "@material-ui/lab";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";

let _this;

export class Upload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            type: 'turkcell',
            sampleSigns: [
                {groupName: '', groupDate: null, description: '', type: 'sample', id: null},
            ],
            referenceSign: [
                {groupName: '', groupDate: null, description: '', type: 'reference', id: null}
            ],
            hideButton: false,
            sampleType: [],
            referenceType: [],
            canContinueToDashboard: false,
            showLastUploaded: false,
            showLastUploadedList: [],
            fileNames : []
        };
        this.caseUUID = sessionStorage.getItem('responseCaseId');
        _this = this;
        this.fileData = [];
        this.fileData['groups'] = [];
        this.fileData['reference'] = [];
        this.refUploded = false;
        this.sampleUploaded = false;
        this.createSampleGroup = this.createSampleGroup.bind(this);
        this.handleCloseHashList = this.handleCloseHashList.bind(this);

    }

    componentDidMount() {
        // Ensure moment locale is set with Monday as first day of week
        if (localStorage.getItem('_lang') === 'tr' || !localStorage.getItem('_lang')) {
            moment.locale('tr');
            moment.updateLocale('tr', {
                week: {
                    dow: 1, // Monday is the first day of the week
                    doy: 4  // The week that contains Jan 4th is the first week of the year
                }
            });
        }
        this.setState({sampleType: [], referenceType: []});
    }

    handleCloseHashList() {
        this.setState({showLastUploaded: false})
    }

    addSignatureToGroup = async (files, caseId, groupId, type = 'groups', signatureType = 'techsign') => {

        const data = new FormData();
        data.append('signature', files.file);

        try {
            const response = await fetch(customConstants.apiUrl + "/cases/" + caseId + "/group/" + groupId + "/signature/upload/" + signatureType, {
                method: 'POST',
                headers: {
                    'Authorization': forensicLib.getAuthHeader(),
                    'Accept': 'application/json'
                },
                body: data
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (err) {
            console.error('Error uploading signature:', err);
            // Don't set loading to false here - let the calling function handle it
            return null;
        }

    }

    createGroup = async (item, type) => {

        if (typeof item !== 'undefined') {

            try {

                let data = {
                    "groupName": item.groupName || (type === 'reference' ? 'Reference' : ''),
                    "description": item.description || (type === 'reference' ? 'Reference Sign' : ''),
                }

                console.log(`createGroup called for ${type}. Item data:`, {
                    groupName: item.groupName,
                    groupDate: item.groupDate,
                    groupDateType: typeof item.groupDate,
                    isDate: item.groupDate instanceof Date,
                    isNull: item.groupDate === null,
                    isUndefined: item.groupDate === undefined,
                    isEmptyString: item.groupDate === '',
                    stringValue: String(item.groupDate)
                });

                if (type === 'reference') {
                    // Use provided groupName and description, or defaults
                    if (!data.groupName) {
                        data.groupName = 'Reference';
                    }
                    if (!data.description) {
                        data.description = 'Reference Sign';
                    }
                    // Use provided date or current date
                    // item.groupDate can be: Date object, moment object, string, null, undefined, or empty string
                    if (item.groupDate && item.groupDate !== '' && item.groupDate !== null && item.groupDate !== undefined) {
                        // Check if it's already a Date object
                        let dateMoment;
                        if (item.groupDate instanceof Date) {
                            console.log('Date is a Date object, converting to moment');
                            dateMoment = moment(item.groupDate);
                        } else if (moment.isMoment(item.groupDate)) {
                            console.log('Date is a moment object');
                            dateMoment = item.groupDate;
                        } else {
                            console.log('Date is a string or other type, parsing:', item.groupDate);
                            dateMoment = moment(item.groupDate);
                        }
                        
                        if (dateMoment.isValid()) {
                            data.groupDate = dateMoment.toISOString().slice(0, -5) + "Z";
                            console.log('Using provided date for reference group:', data.groupDate);
                        } else {
                            console.warn('Invalid date provided for reference group, using current date. Date value:', item.groupDate, 'Type:', typeof item.groupDate, 'Moment valid:', dateMoment.isValid());
                            data.groupDate = moment(new Date()).toISOString().slice(0, -5) + "Z";
                        }
                    } else {
                        console.log('No date provided for reference group, using current date. groupDate value:', item.groupDate);
                        data.groupDate = moment(new Date()).toISOString().slice(0, -5) + "Z";
                    }
                } else {
                    // For sample groups, date is required
                    if (item.groupDate && item.groupDate !== '' && item.groupDate !== null && item.groupDate !== undefined) {
                        // Check if it's already a Date object
                        let dateMoment;
                        if (item.groupDate instanceof Date) {
                            console.log('Date is a Date object, converting to moment');
                            dateMoment = moment(item.groupDate);
                        } else if (moment.isMoment(item.groupDate)) {
                            console.log('Date is a moment object');
                            dateMoment = item.groupDate;
                        } else {
                            console.log('Date is a string or other type, parsing:', item.groupDate);
                            dateMoment = moment(item.groupDate);
                        }
                        
                        if (dateMoment.isValid()) {
                            data.groupDate = dateMoment.toISOString().slice(0, -5) + "Z";
                            console.log('Using provided date for sample group:', data.groupDate);
                        } else {
                            console.error('Invalid date provided for sample group. Date value:', item.groupDate, 'Type:', typeof item.groupDate, 'Moment valid:', dateMoment.isValid());
                            throw new Error('Geçersiz tarih değeri: ' + item.groupDate);
                        }
                    } else {
                        console.error('No date provided for sample group. groupDate value:', item.groupDate, 'Type:', typeof item.groupDate);
                        throw new Error('Tarih alanı zorunludur');
                    }
                }

                if (type === 'groups') {
                    data.status = "sample";
                } else {
                    data.status = "reference";
                }

                console.log(`Creating ${type} group with data:`, data);

                const response = await fetch(customConstants.apiUrl + "/cases/" + _this.caseUUID + "/group", {
                    method: 'POST',
                    headers: {
                        Authorization: forensicLib.getAuthHeader(),
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log(`Group created successfully:`, result);
                return result;

            } catch (e) {
                console.error('Error creating group:', e);
                throw e; // Re-throw to let caller handle it
            }

        } else {
            throw new Error('Item is undefined');
        }

    }

    handleChangeType = (event) => {
        // Update default type and first reference group type
        const newType = event.target.value;
        this.setState({type: newType});
        // Also update first reference group type if it exists
        if (this.state.referenceType.length === 0 || typeof this.state.referenceType[0] === 'undefined') {
            let currentTypes = this.state.referenceType;
            currentTypes[0] = newType;
            this.setState({referenceType: currentTypes});
        }
    }

    handleChangeTypeSample = (event, i) => {
        let curentTypes = this.state.sampleType;
        curentTypes[i] = event.target.value;

        this.setState({sampleType: curentTypes}, () => {
            console.log(_this.state.sampleType);
        });
    }

    handleChangeTypeReference = (event, i) => {
        let curentTypes = this.state.referenceType;
        curentTypes[i] = event.target.value;

        this.setState({referenceType: curentTypes}, () => {
            console.log(_this.state.referenceType);
        });
    }

    createSampleGroup = async (type = 'groups') => {

        const hasUploadedFiles = type === 'groups' ? this.sampleUploaded === true : this.refUploded === true;

        if (hasUploadedFiles) {

            _this.setState({loading: true});

            // Deep copy with Date object preservation
            let lastItem;
            if (type === 'groups') {
                lastItem = this.state.sampleSigns.map(item => ({
                    ...item,
                    groupDate: item.groupDate instanceof Date ? new Date(item.groupDate) : item.groupDate
                }));
            } else {
                lastItem = this.state.referenceSign.map(item => ({
                    ...item,
                    groupDate: item.groupDate instanceof Date ? new Date(item.groupDate) : item.groupDate
                }));
            }

            console.log(`Starting ${type} group processing. Total groups: ${lastItem.length}`);
            console.log(`${type} groups data:`, lastItem.map((item, idx) => ({
                index: idx,
                groupName: item.groupName,
                groupDate: item.groupDate,
                groupDateType: typeof item.groupDate,
                isDate: item.groupDate instanceof Date
            })));

            try {
                if (typeof lastItem !== 'undefined' && lastItem.length > 0) {
                    // Process all groups sequentially to ensure proper order
                    for (let k = 0; k < lastItem.length; k++) {
                        const inner = lastItem[k];

                        console.log(`Processing ${type} group ${k + 1}/${lastItem.length}:`, {
                            groupName: inner.groupName,
                            groupDate: inner.groupDate,
                            groupDateType: typeof inner.groupDate,
                            isDate: inner.groupDate instanceof Date,
                            hasFiles: _this.fileData[type][k] && _this.fileData[type][k].length > 0
                        });

                        // Check if there are files for this group
                        if (!_this.fileData[type][k] || _this.fileData[type][k].length === 0) {
                            console.log(`No files for ${type} group ${k}, skipping`);
                            continue;
                        }

                        // Initialize signatures array for this group
                        if (typeof lastItem[k].signatures === 'undefined') {
                            lastItem[k].signatures = [];
                            lastItem[k].names = [];
                        }

                        let groupId;
                        try {
                            console.log(`Creating ${type} group ${k + 1} with data:`, {
                                groupName: inner.groupName,
                                groupDate: inner.groupDate,
                                groupDateType: typeof inner.groupDate
                            });
                            groupId = await _this.createGroup(inner, type);
                        } catch (error) {
                            console.error(`Error creating group ${k} for ${type}:`, error);
                            console.error(`Group data that failed:`, inner);
                            _this.setState({hideButton: false});
                            NotificationManager.error('Grup oluşturulamadı (Group ' + (k + 1) + '): ' + (error.message || error), '', 15000);
                            continue; // Skip this group and continue with next
                        }

                        if (typeof groupId !== 'undefined' && groupId !== null) {
                            lastItem[k].id = groupId;
                            
                            // Track total files and successful uploads for this group
                            const totalFiles = _this.fileData[type][k].length;
                            let successfulUploads = 0;
                            let failedUploads = 0;

                            // Process all files for this group
                            for (let j = 0; j < _this.fileData[type][k].length; j++) {
                                const innersign = _this.fileData[type][k][j];
                                const signatureType = type === 'groups' 
                                    ? (typeof _this.state.sampleType[k] !== 'undefined' ? _this.state.sampleType[k] : 'turkcell')
                                    : (typeof _this.state.referenceType[k] !== 'undefined' ? _this.state.referenceType[k] : (k === 0 ? _this.state.type : 'turkcell'));
                                
                                try {
                                    const incomingId = await _this.addSignatureToGroup(innersign, _this.caseUUID, lastItem[k].id, type, signatureType);

                                    if (typeof incomingId !== 'undefined' && typeof incomingId.id !== 'undefined' && incomingId.id !== null) {
                                        lastItem[k].signatures.push(incomingId);
                                        lastItem[k].names.push(innersign);
                                        successfulUploads++;
                                        console.log(`Successfully uploaded signature ${j + 1}/${totalFiles} for ${type} group ${k}`);
                                    } else {
                                        failedUploads++;
                                        console.error(`Failed to upload signature ${j + 1}/${totalFiles} for ${type} group ${k}`);
                                        NotificationManager.error(global.strings.sign_could_not_read + ' (Group ' + (k + 1) + ', File ' + (j + 1) + ')', '', 15000);
                                    }
                                } catch (error) {
                                    failedUploads++;
                                    console.error(`Error uploading signature ${j + 1}/${totalFiles} for ${type} group ${k}:`, error);
                                    NotificationManager.error(global.strings.sign_could_not_read + ' (Group ' + (k + 1) + ', File ' + (j + 1) + ')', '', 15000);
                                }
                            }

                            console.log(`${type} Group ${k + 1}: ${successfulUploads}/${totalFiles} signatures uploaded successfully`);
                            
                            if (successfulUploads === 0) {
                                console.warn(`No signatures were successfully uploaded for ${type} group ${k}`);
                            }

                        } else {
                            console.error(`Failed to create group for ${type} group ${k}`);
                            _this.setState({hideButton: false});
                            NotificationManager.error('Grup oluşturulamadı (Group ' + (k + 1) + ')', '', 15000);
                        }
                    }

                    // Update state after all groups are processed - wait for state update
                    await new Promise((resolve) => {
                        if (type === 'groups') {
                            _this.setState({sampleSigns: lastItem}, () => {
                                console.log('Sample signs state updated:', lastItem);
                                resolve();
                            });
                        } else {
                            _this.setState({referenceSign: lastItem}, () => {
                                console.log('Reference signs state updated:', lastItem);
                                resolve();
                            });
                        }
                    });
                    
                    // Return the updated item
                    return lastItem;
                } else {
                    console.warn(`No items to process for ${type}`);
                    return null;
                }
            } catch (e) {
                _this.setState({hideButton: false});
                console.error(`Error in createSampleGroup for ${type}:`, e);
                NotificationManager.error('İmza yükleme sırasında hata oluştu', '', 15000);
                return null;
            }

        } else {
            console.warn(`No uploaded files for ${type}`);
        }
        
        return null;

    }

    continueToReport = async (anyway = false) => {

        if (anyway === true) {
            this.setState({showLastUploaded: false}, () => {
                _this.submitFiles();
            });
            return;
        }

        this.setState({hideButton: true});

        let grpupRequiredMissing = false;
        let ref = _this.state.referenceSign;
        let refSample = _this.state.sampleSigns;

        // Check reference groups
        if (this.refUploded === true) {
            ref.filter(function (value) {
                // For reference groups, date is optional (will use current date if not provided)
                if (value.groupName === '') {
                    grpupRequiredMissing = true;
                }
            });
        }

        // Check sample groups
        if (this.sampleUploaded === true) {
            refSample.filter(function (value) {
                // For sample groups, both name and date are required
                if (value.groupName === '' || !value.groupDate || value.groupDate === null || value.groupDate === '') {
                    grpupRequiredMissing = true;
                }
            });
        }

        if (grpupRequiredMissing === true) {

            this.setState({hideButton: false}, () => {
                return NotificationManager.warning(global.strings.missingInformation);
            });
            return;

        } else {

            let already = false;
            let hasReferenceFiles = false;

            // Check if there are any reference files
            if (_this.fileData['reference'].length > 0) {
                for (let refIndex = 0; refIndex < _this.fileData['reference'].length; refIndex++) {
                    if (_this.fileData['reference'][refIndex] && _this.fileData['reference'][refIndex].length > 0) {
                        hasReferenceFiles = true;
                        break;
                    }
                }
            }

            if (hasReferenceFiles) {
                // Check all reference files for duplicates
                let checkPromises = [];
                for (let refIndex = 0; refIndex < _this.fileData['reference'].length; refIndex++) {
                    if (_this.fileData['reference'][refIndex] && _this.fileData['reference'][refIndex].length > 0) {
                        const refType = (typeof _this.state.referenceType[refIndex] !== 'undefined') 
                            ? _this.state.referenceType[refIndex] 
                            : _this.state.type;
                        
                        _this.fileData['reference'][refIndex].forEach(function (files) {
                            const data = new FormData();
                            data.append('signature', files.file);

                            checkPromises.push(
                                fetch(customConstants.apiUrl + "/cases/check-signature-present/" + refType, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': forensicLib.getAuthHeader(),
                                        'Accept': 'application/json'
                                    },
                                    body: data
                                })
                                    .then(response => response.json())
                                    .then(async result => {
                                        try {
                                            if (result.numberOfCases > 0) {
                                                already = true;
                                                _this.setState({showLastUploadedList: result.cases, showLastUploaded: true});
                                            }
                                        } catch (e) {
                                            console.log(e);
                                        }
                                        return result;
                                    }).catch(err => {
                                        console.log(err);
                                    })
                            );
                        });
                    }
                }

                await Promise.all(checkPromises).then(() => {
                    _this.setState({loading: false, hideButton: false});
                    if (!already) {
                        _this.submitFiles();
                    }
                });
            } else {
                this.setState({hideButton: false}, () => {
                    return NotificationManager.warning(global.strings.atleastOneSign);
                });
            }

        }


    }

    async submitFiles() {
        if (_this.refUploded === true) {

            console.log('Starting file submission...');
            console.log('Reference fileData:', _this.fileData['reference']);
            console.log('Sample fileData:', _this.fileData['groups']);

            // Process reference groups first
            const updatedReferenceSign = await _this.createSampleGroup('reference');
            
            if (!updatedReferenceSign) {
                _this.setState({loading: false, hideButton: false}, () => {
                    return NotificationManager.error('Referans imzalar yüklenemedi', '', 15000);
                });
                return;
            }

            // Verify all reference groups have at least one signature
            let allReferenceGroupsValid = true;
            let totalReferenceSignatures = 0;
            for (let i = 0; i < updatedReferenceSign.length; i++) {
                const expectedFiles = _this.fileData['reference'][i] ? _this.fileData['reference'][i].length : 0;
                const actualSignatures = updatedReferenceSign[i].signatures ? updatedReferenceSign[i].signatures.length : 0;
                totalReferenceSignatures += actualSignatures;
                
                if (expectedFiles > 0 && actualSignatures === 0) {
                    allReferenceGroupsValid = false;
                    console.error(`Reference group ${i + 1} has ${expectedFiles} files but 0 signatures uploaded`);
                } else {
                    console.log(`Reference group ${i + 1}: ${actualSignatures}/${expectedFiles} signatures uploaded`);
                }
            }

            if (!allReferenceGroupsValid || totalReferenceSignatures === 0) {
                _this.setState({loading: false, hideButton: false}, () => {
                    return NotificationManager.error('Tüm referans imzalar yüklenemedi. Lütfen tekrar deneyin.', '', 15000);
                });
                return;
            }

            // Save reference signs to sessionStorage
            sessionStorage.setItem('reference', JSON.stringify(updatedReferenceSign));
            console.log('Reference signs saved to sessionStorage:', updatedReferenceSign);

            // Process sample groups if any
            if (_this.sampleUploaded === true) {
                const updatedSampleSigns = await _this.createSampleGroup();
                
                if (updatedSampleSigns) {
                    // Verify sample groups
                    let allSampleGroupsValid = true;
                    for (let i = 0; i < updatedSampleSigns.length; i++) {
                        const expectedFiles = _this.fileData['groups'][i] ? _this.fileData['groups'][i].length : 0;
                        const actualSignatures = updatedSampleSigns[i].signatures ? updatedSampleSigns[i].signatures.length : 0;
                        
                        if (expectedFiles > 0 && actualSignatures === 0) {
                            allSampleGroupsValid = false;
                            console.error(`Sample group ${i + 1} has ${expectedFiles} files but 0 signatures uploaded`);
                        } else {
                            console.log(`Sample group ${i + 1}: ${actualSignatures}/${expectedFiles} signatures uploaded`);
                        }
                    }

                    if (allSampleGroupsValid) {
                        sessionStorage.setItem('samples', JSON.stringify(updatedSampleSigns));
                        console.log('Sample signs saved to sessionStorage:', updatedSampleSigns);
                    } else {
                        console.warn('Some sample groups failed to upload, but continuing...');
                        sessionStorage.setItem('samples', JSON.stringify(updatedSampleSigns));
                    }
                }
            }

            _this.setState({loading: false, hideButton: false}, () => {
                console.log('All files processed. Redirecting to dashboard...');
                console.log('Final reference signs:', updatedReferenceSign);
                // Redirect to dashboard after a short delay to ensure state is updated
                setTimeout(() => {
                    _this.props.history.push('/dashboard');
                }, 500);
            });

        } else {
            _this.setState({loading: false, hideButton: false}, () => {
                return NotificationManager.warning(global.strings.atleastOneSign);
            });
        }
    }

    addOtherSigns() {
        let currentSigns = this.state.sampleSigns;
        currentSigns.push({groupName: '', groupDate: null, description: '', data: []});
        this.setState({sampleSigns: currentSigns});
    }

    addOtherReferenceSigns() {
        let currentSigns = this.state.referenceSign;
        currentSigns.push({groupName: '', groupDate: null, description: '', type: 'reference', id: null});
        this.setState({referenceSign: currentSigns});
    }

    updateGroupName(v, isReference, i) {
        if (isReference) {
            let currentName = this.state.referenceSign;
            currentName[i].groupName = v.target.value;
            this.setState({referenceSign: currentName}, () => {
                // console.log(this.state.referenceSign);
            });
        } else {
            let currentName = this.state.sampleSigns;
            currentName[i].groupName = v.target.value;
            this.setState({sampleSigns: currentName}, () => {
                // console.log(this.state.sampleSigns);
            });
        }
    }

    updateDescription(v, isReference, i) {
        if (isReference) {
            let currentName = this.state.referenceSign;
            currentName[i].description = v.target.value;
            this.setState({referenceSign: currentName}, () => {
                // console.log(this.state.referenceSign);
            });
        } else {
            let currentName = this.state.sampleSigns;
            currentName[i].description = v.target.value;
            this.setState({sampleSigns: currentName}, () => {
                // console.log(this.state.sampleSigns);
            });
        }
    }

    updateDate(v, isReference, i) {
        // DatePicker returns a Date object or null
        // Store it directly - moment can handle Date objects
        if (isReference) {
            let currentName = this.state.referenceSign;
            currentName[i].groupDate = v; // v is a Date object or null
            this.setState({referenceSign: currentName}, () => {
                console.log('Reference date updated:', v, 'for group', i);
            });
        } else {
            let currentName = this.state.sampleSigns;
            currentName[i].groupDate = v; // v is a Date object or null
            this.setState({sampleSigns: currentName}, () => {
                console.log('Sample date updated:', v, 'for group', i);
            });
        }
    }

    uploadSigFile = (file, isRefernce, i) => {

        let files = Array.from(file);
        _this.setState({loading: true});


        files.map(function (f) {

            // console.log(f);

            const data = new FormData();
            const allowedExtensions = /(\.sig)$/i;

            if (_this.state.sampleSigns.length >= 10) {
                _this.setState({loading: false});
                return NotificationManager.warning(global.strings.max_two_file);
            } else if (typeof f !== 'undefined' && !allowedExtensions.exec(f.name)) {
                _this.setState({loading: false});
                return NotificationManager.error(global.strings.upload_file_type_error);
            } else if (typeof f !== 'undefined' && allowedExtensions.exec(f.name)) {

                data.append('signature', f);
                _this.setState({uploading: true});

                if (isRefernce === true) {

                    // i is the index for reference group
                    if (typeof i === 'undefined' || i === null) {
                        i = 0;
                    }

                    if (typeof _this.fileData['reference'][i] === 'undefined') {
                        _this.fileData['reference'][i] = [];
                    }

                    // Check max file limit per group (similar to sample groups)
                    if (_this.fileData['reference'][i].length >= 10) {
                        _this.setState({loading: false});
                        return NotificationManager.warning(global.strings.max_two_file);
                    }

                    _this.fileData['reference'][i].push({filename: f.name, file: f});
                    _this.sampleUploaded = true;
                    _this.setState({loading: false});
                    _this.refUploded = true;
                    return NotificationManager.success(global.strings.upload_success_reference);

                } else {

                    if (typeof _this.fileData['groups'][i] === 'undefined') {
                        _this.fileData['groups'][i] = [];
                    }

                    _this.fileData['groups'][i].push({filename: f.name, file: f});
                    _this.sampleUploaded = true;
                    _this.setState({loading: false});
                    return NotificationManager.success(global.strings.upload_success_group);
                }

            }
        })


    }

    getCase = async (id) => {

        let samples = [];
        let reference = [];

        this.setState({loading: true});
        fetch(customConstants.apiUrl + "/cases/" + id, {
            method: 'GET',
            headers: {
                Authorization: forensicLib.getAuthHeader(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(response => response.json())
            .then(result => {

                sessionStorage.setItem('responseCaseId', result.uuid);
                sessionStorage.setItem('caseId', result.caseId);
                sessionStorage.setItem('tckn', result.tckn);
                sessionStorage.setItem('specialityNo', result.specialityNo);
                sessionStorage.setItem('requestAuthority', result.requestAuthority);
                sessionStorage.setItem('date', result.caseDate);


                // console.log(item);

                try {
                    result.groups.map(function (item) {
                        if (item.status === 'reference') {
                            reference.push(item);
                        } else {
                            samples.push(item);
                        }
                    });
                } catch (e) {
                    console.log(e);
                }


                sessionStorage.setItem('reference', JSON.stringify(reference));
                sessionStorage.setItem('samples', JSON.stringify(samples));

                this.props.history.push('/dashboard');

            })
            .catch(err => {
                //console.log(err);
                this.setState({loading: false});
                // return NotificationManager.error(err);
            });


    }

    render() {
        return (
            <div>
                <Loading loading={this.state.loading} background="rgba(255,255,255,.7)" loaderColor="#0D386B"/>
                <div className="limiter">
                    <Dialog
                        fullWidth={'md'}
                        open={this.state.showLastUploaded}
                        onClose={this.handleCloseHashList}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{global.strings.last_hash_list}</DialogTitle>
                        <DialogContent>

                            <Alert severity={'warning'}>{global.strings.last_hash_list_desc}</Alert>
                            <Grid container spacing={3}>

                                <table style={{padding: 0, margin: 20, marginTop: 30, width: '100%'}}>
                                    <thead>
                                    <th>{global.strings.caseId}</th>
                                    <th>{global.strings.expertId}</th>
                                    <th>{global.strings.created_at}</th>
                                    </thead>
                                    {this.state.showLastUploadedList.map(function (v, k) {
                                        return <tr onClick={() => _this.getCase(v.uuid)}
                                                   style={{
                                                       listStyle: 'none',
                                                       cursor: 'pointer',
                                                       padding: '7px 3px',
                                                       backgroundColor: (k % 2 == 1) ? 'rgb(221 221 221 / 26%)' : 'rgb(221 221 221 / 16%)'
                                                   }} key={k}>
                                            <td>{v.caseId}</td>
                                            <td>{v.specialityNo}</td>
                                            <td>{moment(v.createdAt).format('DD-MM-YYYY')}</td>
                                        </tr>
                                    })}
                                </table>

                                <div onClick={() => this.continueToReport(true)} lang="en"
                                     className="login100-form-btn" style={{display: 'initial'}}>
                                    {global.strings.continue_anyway}
                                    <svg x="0px" y="0px" width="16px" height="16px" style={{marginLeft: 10}}
                                         viewBox="0 0 31.49 31.49"
                                    >
                                        <path fill="#ffffff"
                                              d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
	C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
	c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"></path>
                                    </svg>
                                </div>
                            </Grid>

                        </DialogContent>
                        <DialogActions>

                        </DialogActions>
                    </Dialog>
                    <div className="container-login100">
                        <div className="upload-container">
                            <div className={'row'}>
                                <div className={'col-6'}>
                                    <div className={'upload-inner '}>
                                        <h1 className={'upload-document'}><span className={'upload-icon'}>
                            <svg className={'uploadIcn'} version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px"
                                 width="24px" height="24px" viewBox="0 0 512 512">
<path d="M510.187,238.063L439.749,432H53.124l72.75-194.031C132.061,221.5,151.53,208,169.124,208h320
	C506.718,208,516.218,221.531,510.187,238.063z M31.03,399.813L95.936,226.75c10.813-28.938,42.281-50.75,73.188-50.75h278.875
	c0-17.688-14.313-32-32-32h-224l-32-64h-128c-17.688,0-32,14.313-32,32v256C-0.001,385.344,13.811,399.25,31.03,399.813z"/>
</svg>

                        </span>{global.strings.uploadDocument}</h1>

                                        {this.state.referenceSign.map((item, i) => {
                                            return <div key={i}>
                                                <h3 className={'reference-sign'}
                                                    style={{'marginTop': i > 0 ? '18px' : '0'}}>{i + 1}. {global.strings.referenceSign}</h3>
                                                <div className={'information'}>{global.strings.toBeReference}</div>
                                                <FormControl style={{width: '100%', marginTop: 15}}>
                                                    <InputLabel
                                                        id="demo-customized-select-label-ref">{global.strings.upload_type}</InputLabel>
                                                    <Select
                                                        labelId="demo-customized-select-label-ref"
                                                        id="demo-customized-select-ref"
                                                        defaultValue={'turkcell'}
                                                        value={(typeof this.state.referenceType[i] !== 'undefined') ? this.state.referenceType[i] : (i === 0 ? this.state.type : 'turkcell')}
                                                        onChange={(event) => this.handleChangeTypeReference(event, i)}
                                                    >
                                                        <MenuItem value={'turkcell'}>Turkcell</MenuItem>
                                                        <MenuItem value={'techsign'}>Techsign</MenuItem>
                                                        <MenuItem value={'iso11'}>iso11</MenuItem>
                                                        <MenuItem value={'turktelekom'}>TÜRK TELEKOM</MenuItem>
                                                        <MenuItem value={'vodafone'}>VODAFONE</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <div className={'uploadContainer'}>
                                                    <Dropzone accept=".sig" multiple={true}
                                                              onDropAccepted={acceptedFiles => this.uploadSigFile(acceptedFiles, true, i)}>
                                                        {({getRootProps, getInputProps}) => (
                                                            <section className={'reference-container'}>
                                                                <div {...getRootProps()}>
                                                                    <input {...getInputProps()}  />
                                                                    <p>
                                                                        <svg
                                                                            width="100"
                                                                            height="60"
                                                                            viewBox="0 0 50 43">
                                                                            <path fill="#ccc" d="M27.586,12.712C26.66,10.251,24.284,8.5,21.5,8.5c-0.641,0-1.26,0.093-1.846,0.266
			C18.068,6.205,15.233,4.5,12,4.5c-4.904,0-8.894,3.924-8.998,8.803C1.207,14.342,0,16.283,0,18.5c0,3.312,2.688,6,6,6h6v-2H5.997
			C3.794,22.5,2,20.709,2,18.5c0-1.893,1.317-3.482,3.087-3.896C5.029,14.245,5,13.876,5,13.5c0-3.866,3.134-7,7-7
			c3.162,0,5.834,2.097,6.702,4.975c0.769-0.611,1.739-0.975,2.798-0.975c2.316,0,4.225,1.75,4.473,4h0.03
			c2.203,0,3.997,1.791,3.997,4c0,2.205-1.789,4-3.997,4H20v2h6c3.312,0,6-2.693,6-6C32,15.735,30.13,13.407,27.586,12.712z"/>
                                                                            <polygon fill="#ccc"
                                                                                     points="16,13.5 11,19.5 14,19.5 14,27.5 18,27.5 18,19.5 21,19.5 		"/>
                                                                        </svg>
                                                                        <br/><br/>
                                                                        {global.strings.uploadContainer}
                                                                    </p>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </Dropzone>
                                                    <ul className={'uploaded-files'}>
                                                        {typeof _this.fileData['reference'][i] !== 'undefined' && _this.fileData['reference'][i].length > 0 && _this.fileData['reference'][i].map((item, j) => {
                                                            return <li key={'ref-signs-' + i + '-' + j}>
                                                                <svg version="1.1" x="0px" y="0px" width={24} height={24}
                                                                     viewBox="0 0 1200 1200">
                                                                    <path fill="#7AC043"
                                                                          d="M50,662.7l187-134.2l149.6,237.6c0,0,303.6-475.2,763.4-624.8v37.4c0,0-466.4,198-748,880L50,662.7z"/>
                                                                </svg>
                                                                {item.filename}
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                                <div className={'row'} style={{'marginTop': '15px'}}>
                                                    <div className="flex-row wrap-input100 validate-input col-12">
                                                        <label className="lf--label" style={{'width': '6em'}}
                                                               htmlFor="groupNameRef">
                                                            {global.strings.groupName} *
                                                        </label>
                                                        <input id="groupNameRef" className="lf--input input100"
                                                               maxLength={30}
                                                               value={this.state.referenceSign[i].groupName}
                                                               onChange={(v) => this.updateGroupName(v, true, i)}
                                                               placeholder={global.strings.groupNamePlaceholder}
                                                               type="text"/>
                                                        <span className="focus-input100"></span>
                                                    </div>
                                                </div>
                                                <div className={'row'} style={{'marginTop': '15px'}}>
                                                    <div className="flex-row wrap-input100 validate-input col-12">
                                                        <label className="lf--label" style={{'width': '94px'}} htmlFor="dateRef">
                                                            {global.strings.date} *
                                                        </label>
                                                        <MuiPickersUtilsProvider locale="tr" libInstance={moment} utils={MomentUtils}>
                                                            <FormControl style={{width: '100%'}}>
                                                                <KeyboardDatePicker
                                                                    inputVariant="standard"
                                                                    format="DD-MM-YYYY"
                                                                    value={this.state.referenceSign[i].groupDate || null}
                                                                    onChange={(v) => this.updateDate(v, true, i)}
                                                                    okLabel={React.createElement('span', null, global.strings.ok)}
                                                                    cancelLabel={React.createElement('span', null, global.strings.cancel)}
                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            height: '50px',
                                                                            padding: '10px 14px',
                                                                            borderBottom: 'none',
                                                                            border: '1px solid #f3f3f3',
                                                                            color: '#666666'
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            padding: '0',
                                                                            color: '#666666'
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                </div>
                                                <div className={'row'}>
                                                    <div className="flex-row wrap-input100 validate-input col-12"
                                                         style={{'marginTop': 10}}>
                                                        <label className="lf--label" style={{'width': '6em'}}
                                                               htmlFor="descriptionRef">
                                                            {global.strings.description}
                                                        </label>
                                                        <textarea id="descriptionRef" className="lf--input input100 lf--textarea"
                                                                  value={this.state.referenceSign[i].description}
                                                                  onChange={(v) => this.updateDescription(v, true, i)}
                                                                  placeholder={global.strings.description}
                                                        />
                                                        <span className="focus-input100"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                        <div className={'row'} style={{'marginTop': '15px'}}>
                                            <div className={'col-12'}>
                                                <h5 onClick={() => this.addOtherReferenceSigns()} className={'add-other'}><span
                                                    className={'add-icon'}>
                            <svg className={'uploadIcn'} version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px"
                                 width="16px" height="16px" viewBox="0 0 24 24">
<path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>

                        </span>{global.strings.addOtherSigns}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className={'upload-inner'}>
                                        {this.state.sampleSigns.map((item, i) => {

                                            return <div key={i}>
                                                <h3 className={'group-sign'}
                                                    style={{'marginTop': '18px'}}>{i + 2}. {global.strings.sampleSign}</h3>
                                                <div className={'information'}>{global.strings.toBeSample}</div>
                                                <FormControl style={{width: '100%', marginTop: 15}}>
                                                    <InputLabel
                                                        id="demo-customized-select-label">{global.strings.upload_type}</InputLabel>
                                                    <Select

                                                        labelId="demo-customized-select-label"
                                                        id="demo-customized-select"
                                                        defaultValue={'turkcell'}
                                                        value={(typeof this.state.sampleType[i] !== 'undefined') ? this.state.sampleType[i] : 'turkcell'}
                                                        onChange={(event) => this.handleChangeTypeSample(event, i)}
                                                    >
                                                        <MenuItem value={'turkcell'}>Turkcell</MenuItem>
                                                        <MenuItem value={'techsign'}>Techsign</MenuItem>
                                                        <MenuItem value={'iso11'}>iso11</MenuItem>
                                                        <MenuItem value={'turktelekom'}>TÜRK TELEKOM</MenuItem>
                                                        <MenuItem value={'vodafone'}>VODAFONE</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <div className={'uploadContainer'}>
                                                    <Dropzone accept=".sig" multiple
                                                              onDropAccepted={acceptedFiles => this.uploadSigFile(acceptedFiles, false, i)}>
                                                        {({getRootProps, getInputProps}) => (
                                                            <section>
                                                                <div {...getRootProps()}>
                                                                    <input {...getInputProps()} />
                                                                    <p>
                                                                        <svg
                                                                            width="100"
                                                                            height="60"
                                                                            viewBox="0 0 50 43">
                                                                            <path fill="#ccc" d="M27.586,12.712C26.66,10.251,24.284,8.5,21.5,8.5c-0.641,0-1.26,0.093-1.846,0.266
			C18.068,6.205,15.233,4.5,12,4.5c-4.904,0-8.894,3.924-8.998,8.803C1.207,14.342,0,16.283,0,18.5c0,3.312,2.688,6,6,6h6v-2H5.997
			C3.794,22.5,2,20.709,2,18.5c0-1.893,1.317-3.482,3.087-3.896C5.029,14.245,5,13.876,5,13.5c0-3.866,3.134-7,7-7
			c3.162,0,5.834,2.097,6.702,4.975c0.769-0.611,1.739-0.975,2.798-0.975c2.316,0,4.225,1.75,4.473,4h0.03
			c2.203,0,3.997,1.791,3.997,4c0,2.205-1.789,4-3.997,4H20v2h6c3.312,0,6-2.693,6-6C32,15.735,30.13,13.407,27.586,12.712z"/>
                                                                            <polygon fill="#ccc"
                                                                                     points="16,13.5 11,19.5 14,19.5 14,27.5 18,27.5 18,19.5 21,19.5 		"/>
                                                                        </svg>
                                                                        <br/><br/>
                                                                        {global.strings.uploadContainer}
                                                                    </p>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </Dropzone>
                                                    <ul className={'uploaded-files'}>
                                                        {typeof _this.fileData['groups'][i] !== 'undefined' && _this.fileData['groups'][i].length > 0 && _this.fileData['groups'][i].map((item, i) => {
                                                            return <li key={'sample-uploaded' + i}>
                                                                <svg version="1.1" x="0px" y="0px" width={24}
                                                                     height={24}
                                                                     viewBox="0 0 1200 1200"
                                                                >
                                                                    <path fill="#7AC043"
                                                                          d="M50,662.7l187-134.2l149.6,237.6c0,0,303.6-475.2,763.4-624.8v37.4c0,0-466.4,198-748,880L50,662.7z"/>
                                                                </svg>
                                                                {item.filename}
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                                <div className={'row'} style={{'marginTop': '15px'}}>
                                                    <div className="flex-row wrap-input100 validate-input col-12">
                                                        <label className="lf--label" style={{'width': '6em'}}
                                                               htmlFor="groupName">
                                                            {global.strings.groupName} *
                                                        </label>
                                                        <input id="groupName" className="lf--input input100"
                                                               maxLength={30}
                                                               value={this.state.email}
                                                               onChange={(v) => this.updateGroupName(v, false, i)}
                                                               placeholder={global.strings.groupNamePlaceholder}
                                                               type="text"/>
                                                        <span className="focus-input100"></span>
                                                    </div>
                                                </div>
                                                <div className={'row'} style={{'marginTop': '15px'}}>
                                                    <div className="flex-row wrap-input100 validate-input col-12">
                                                        <label className="lf--label" style={{'width': '94px'}} htmlFor="date">
                                                            {global.strings.date} *
                                                        </label>
                                                        <MuiPickersUtilsProvider locale="tr" libInstance={moment} utils={MomentUtils}>
                                                            <FormControl style={{width: '100%'}}>
                                                                <KeyboardDatePicker
                                                                    inputVariant="standard"
                                                                    format="DD-MM-YYYY"
                                                                    value={this.state.sampleSigns[i].groupDate || null}
                                                                    onChange={(v) => this.updateDate(v, false, i)}
                                                                    okLabel={React.createElement('span', null, global.strings.ok)}
                                                                    cancelLabel={React.createElement('span', null, global.strings.cancel)}
                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            height: '50px',
                                                                            padding: '10px 14px',
                                                                            borderBottom: 'none',
                                                                            border: '1px solid #f3f3f3',
                                                                            color: '#666666'
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            padding: '0',
                                                                            color: '#666666'
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: '100%'
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                </div>
                                                <div className={'row'}>
                                                    <div className="flex-row wrap-input100 validate-input col-12">
                                                        <label className="lf--label" style={{'width': '6em'}}
                                                               htmlFor="groupName">
                                                            {global.strings.description}
                                                        </label>
                                                        <textarea id="groupName"
                                                                  className="lf--input input100 lf--textarea"
                                                                  value={this.state.description}
                                                                  onChange={(v) => this.updateDescription(v, false, i)}
                                                                  placeholder={global.strings.description}
                                                        />
                                                        <span className="focus-input100"></span>
                                                    </div>

                                                </div>
                                            </div>
                                        })
                                        }

                                        <div className={'row'}>
                                            <div className={'col-8'}>
                                                <h5 onClick={() => this.addOtherSigns()} className={'add-other'}><span
                                                    className={'add-icon'}>
                            <svg className={'uploadIcn'} version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px"
                                 width="16px" height="16px" viewBox="0 0 24 24">
<path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>

                        </span>{global.strings.addOtherSigns}</h5>
                                            </div>
                                            <div className={'col-4'}>
                                                {(this.state.hideButton === false) ?
                                                    <div className="container-login100-form-btn">
                                                        <div onClick={() => this.continueToReport()} lang="en"
                                                             className="login100-form-btn">
                                                            <svg x="0px" y="0px" width="25px" height="23px"
                                                                 viewBox="0 0 31.49 31.49"
                                                            >
                                                                <path fill="#ffffff"
                                                                      d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
	C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
	c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"></path>
                                                            </svg>
                                                        </div>
                                                    </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

}

export default withRouter(Upload);



